<script setup>
    import { ref } from "vue";
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    //import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
    import TableAdvanced from "@/Components/TableAdvanced.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

    defineProps({
        origin_type: String,
        files: Array,
        columnas: Array,
        message: String
    });

    const rutaPrefijo = ref('file');
    const modulo = ref('Documento');
    const modulos = ref('Documentos');

</script>

<template>
    <Head title="Documentos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                <template v-if="origin_type == 'file_guideforcourse'">
                    Guías de estudio <!-- In basebutton: @click="route('dashboard')"-->
                </template>
                <template v-else-if="origin_type == 'file_forlevel'">
                    Documentos iniciales por nivel educativo
                </template>
                <template v-else>
                    Documentos
                </template>
                <div v-if="message">{{ message }}</div>
                <Link :href="route(rutaPrefijo+'-create', {'origin_type': origin_type})">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>
                <!--<Link :href="route('fileforlevel-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>-->
                <!--
                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->
            </h2>   
        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        
                        <CardBox v-if="files.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced :modulo="modulo" :modulos="modulos" :data="files" :fields="columnas" updateable :ruta="rutaPrefijo" /><!--deleteable-->
                            </div>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>